import React from 'react';
import { DisclaimerStyles } from './Disclaimer.styled';
import PropTypes from 'prop-types';

const Disclaimer = ({ disclaimerContent }) => {
  return (
    <DisclaimerStyles>
      <div className="disclaimer-content">
        {disclaimerContent
          ? disclaimerContent && <p>{disclaimerContent}</p>
          : null}
      </div>
    </DisclaimerStyles>
  );
};

export default Disclaimer;

Disclaimer.propTypes = {
  disclaimerContent: PropTypes.string,
};
